<div class="cv-primary-dialog-container">
  <h1 mat-dialog-title>
    This is primary CV
    <button (click)="cancelDialog()" class="close-btn" isIconButton="true" mat-button>
      <mat-icon svgIcon="close"></mat-icon>
    </button>
  </h1>
  <div class="flex flex-col" mat-dialog-content>
    <section>
      <p>
        Primary CV is used for matching you with new interesting job opportunities in the future.
        <br />
        If you want to delete it, please contact your agent.
      </p>
    </section>
  </div>
  <div mat-dialog-actions>
    <button (click)="cancelDialog()" cdkFocusInitial class="small-button" color="primary" mat-stroked-button>OK</button>
  </div>
</div>
